import { createContext } from 'react'

export interface Consent {
  essential?: boolean
  performance?: boolean
  functional?: boolean
  targetting?: boolean
}

export default createContext({
  openConsent: () => {},
  closeConsent: () => {},
  getConsent: (): Consent => ({}),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  updateConsent: (values: Consent) => {},
  openPreferences: () => {},
  closePreferences: () => {},
  values: {} as Consent,
})
